import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10.29",
  height: "10.2899",
  viewBox: "0 0 10.29 10.2899",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "earth_svgrepo.com",
      opacity: "0.4"
    }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M5.14499 9.78995C7.71034 9.78995 9.78997 7.71032 9.78997 5.14497C9.78997 2.57963 7.71034 0.5 5.14499 0.5C2.57963 0.5 0.5 2.57963 0.5 5.14497C0.5 7.71032 2.57963 9.78995 5.14499 9.78995Z",
        stroke: "currentColor"
      }),
      _createElementVNode("path", {
        id: "Vector_2",
        d: "M2.358 1.75906C2.72042 2.0891 3.46702 2.9912 3.554 3.95931C3.6353 4.86421 4.23258 5.59956 5.14499 5.6095C5.49564 5.61331 5.85024 5.36002 5.84936 5.00937C5.84908 4.90091 5.8312 4.79003 5.80319 4.68808C5.76422 4.54617 5.76078 4.38299 5.84174 4.21601C6.12504 3.63192 6.68221 3.47503 7.12371 3.15782C7.3195 3.01713 7.4981 2.86872 7.57688 2.74917C7.79436 2.41914 8.01179 1.75906 7.90305 1.42902",
        stroke: "currentColor"
      }),
      _createElementVNode("path", {
        id: "Vector_3",
        d: "M9.79001 5.60953C9.637 6.04198 9.52873 7.17721 7.80112 7.19523C7.80112 7.19523 6.27124 7.19523 5.81227 8.06017C5.44509 8.75209 5.65927 9.5017 5.81227 9.79001",
        stroke: "currentColor"
      })
    ], -1)
  ]))]))
}
export default { render: render }